import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import Button from "~/shared/Btn";
import TextareaInput from "~/shared/TextareaInput";
import NumberInput from "~/shared/NumberInput";
import { Content, Header, Footer } from "../styles";
import { Row, Col } from "react-bootstrap";

type GraduationProps = {
    prevStep?: () => void;
    nextStep?: () => void;
    goToStep?: (step: number) => void;
    currentStep: number;
};

const extraFields = {
    number_trainees: {
        name: "Numero de formandos",
        value: "",
        type: "numero",
    },
    number_guests: {
        name: "Numero de convidados",
        value: "",
        type: "numero",
    },
    adicional_info: {
        name: "Informações adicionais",
        value: "",
        type: "texto",
    },
};

const Graduation = ({ nextStep, goToStep }: GraduationProps) => {
    const { values, confirmationStep, handleChange, updateValuesInLocalStorage, setValues } =
        useContext(MultiStepFormContext);

    const [addicionalInfo, setAddicionalInfo] = useState<string>(values?.extra?.adicional_info?.value || "");
    const [trainessNumber, setTrainessNumber] = useState<string>(values?.extra?.number_trainees?.value || "");
    const [guestsNumber, setGuestsNumbero] = useState<string>(values?.extra?.number_guests?.value || "");

    const briefing = `Informações\nNúmero de formandos: ${
        values?.extra?.number_trainees?.value || trainessNumber
    }\nNúmero de convidados: ${values?.extra?.number_guests?.value || guestsNumber}`;

    const handleExtraFieldChange = async (name: string, value: any) => {
        if (Object.keys(extraFields).includes(name)) {
            handleChange(name, { ...extraFields[name], value, type: extraFields[name].type }, { extra: true });
        }
    };

    const validateAndNextStep = () => {
        if (!trainessNumber.length && !guestsNumber.length) {
            return toast.error("As informações de formandos e convidados precisam ser preenchidas!");
        }

        if (confirmationStep) {
            updateValuesInLocalStorage();
            return goToStep(confirmationStep);
        }

        return nextStep();
    };

    useEffect(() => {
        const localValues = JSON.parse(localStorage.getItem("values"));
        if (confirmationStep) {
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        handleChange("briefing", briefing);
    }, [briefing]);

    return (
        <>
            <Header>
                <h1>Defina o briefing do seu job</h1>
                <p>Precisamos de algumas informações para realizar o seu job!</p>
            </Header>

            <Content>
                <div className="title">
                    <p>Informações</p>
                    <div className="bar" />
                    <Row className="input-content">
                        <Col lg={6}>
                            <NumberInput
                                name="number_trainees"
                                label="Número de formandos"
                                value={trainessNumber}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setTrainessNumber(value);
                                }}
                            />
                        </Col>

                        <Col lg={6}>
                            <NumberInput
                                name="number_guests"
                                label="Número de convidados"
                                value={guestsNumber}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setGuestsNumbero(value);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </Content>
            <Content>
                <div className="title">
                    <p>Informações adicionais</p>
                    <div className="bar" />
                    <TextareaInput
                        name="adicional_info"
                        value={addicionalInfo}
                        placeholder="Descreva aqui qualquer informação adicional..."
                        rows={3}
                        onChange={(name: string, value: string) => {
                            handleExtraFieldChange(name, value);
                            setAddicionalInfo(value);
                        }}
                    />
                </div>
            </Content>

            <Footer>
                {confirmationStep ? (
                    <Button block onClick={validateAndNextStep}>
                        Salvar
                    </Button>
                ) : (
                    <>
                        <Button id="clickSegmentNext" block onClick={() => handleChange("category", 0)}>
                            Voltar
                        </Button>
                        <Button id="clickSegmentNext" block onClick={validateAndNextStep}>
                            Continuar
                        </Button>
                    </>
                )}
            </Footer>
        </>
    );
};

export default Graduation;
